module.exports = __webpack_public_path__ + "static/media/browse_content_pers.2b0183ce.svg";